/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { invoiceEmailSettingsUpdate } from '../../axios/invoiceEmailSettingsUpdate'
import type {
	InvoiceEmailSettingsUpdateError,
	InvoiceEmailSettingsUpdatePathParams,
	InvoiceEmailSettingsUpdateRequest,
	InvoiceEmailSettingsUpdateResponse,
} from '../../types/InvoiceEmailSettingsUpdate'

export const invoiceEmailSettingsUpdateMutationKey = () => [{ url: '/:organisation/invoice-email-settings' }] as const

export type InvoiceEmailSettingsUpdateMutationKey = ReturnType<typeof invoiceEmailSettingsUpdateMutationKey>

export type InvoiceEmailSettingsUpdateVariables = {
	organisation: InvoiceEmailSettingsUpdatePathParams['organisation']
	data: InvoiceEmailSettingsUpdateRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceEmailSettingsController.php InvoiceEmailSettingsController::update */
export function useInvoiceEmailSettingsUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		InvoiceEmailSettingsUpdateResponse,
		AxiosError<InvoiceEmailSettingsUpdateError>,
		InvoiceEmailSettingsUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: invoiceEmailSettingsUpdateMutationKey(),
		mutationFn: ({ organisation, data }: InvoiceEmailSettingsUpdateVariables) =>
			invoiceEmailSettingsUpdate(organisation, data, config).then(res => res.data),
		...options,
	})
}
